var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3801 11.1964L9.33041 6.41464L11.3714 4.37363C12.2461 3.49891 12.5377 2.33262 12.2461 1.74948C11.663 1.4579 10.4967 1.74948 9.62198 2.6242L7.58097 4.66521L2.79917 3.61554C2.5076 3.55723 2.27434 3.67386 2.15771 3.90712L1.98277 4.19869C1.86614 4.49026 1.92446 4.78184 2.15771 4.95678L5.24839 6.99779L4.0821 8.74723H2.33266L1.74951 9.33037L3.49895 10.4967L4.66524 12.2461L5.24839 11.663V9.91352L6.99782 8.74723L9.03883 11.8379C9.21378 12.0712 9.50535 12.1295 9.79692 12.0128L10.0885 11.8962C10.3218 11.7213 10.4384 11.488 10.3801 11.1964Z",
    stroke: "#99A1AF",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPlane);
export default __webpack_public_path__ + "static/media/gray_plane.0d01d79577d7e3591b9598cad7917011.svg";
export { ForwardRef as ReactComponent };